import React from 'react';
import { Footer } from 'ui-components';

export const Error503 = () => {
  return (
    <div className="flex min-h-screen flex-col bg-root-background-base">
      <main className="relative z-10 flex-1">
        <div className="hidden pt-40 mac:block">
          <div className="mx-auto max-w-[1200px] px-8">
            <div className="mx-auto flex max-w-[1280px] items-center justify-between">
              <div className="max-w-[40rem] flex-1">
                <h1 className="mb-6 font-root-text-weight-heavy text-[3.75rem] leading-[1.1] text-root-text-color-heading">
                  Whiskers is supervising a quick database update
                </h1>
                <p className="font-root-text-weight-base text-[1.5rem] text-root-text-color-muted">
                  We'll be back—right meow.
                </p>
              </div>
              <div className="flex flex-1 justify-end">
                <img
                  src={'/images/503_desktop.jpg'}
                  className="h-auto w-full max-w-sm object-contain"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="block px-6 pt-16 mac:hidden">
          <div className="mx-auto flex max-w-lg flex-col items-center text-center">
            <div className="mb-12">
              <img
                src={'/images/503_mobile.jpg'}
                className="size-[20rem] object-contain tab:size-[24rem]"
              />
            </div>
            <div>
              <h1 className="mb-6 font-root-text-weight-heavy text-[2.25rem] leading-[1.1] text-root-text-color-heading tab:text-[3rem]">
                Whiskers is supervising a quick database update
              </h1>
              <p className="font-root-text-weight-base text-[1.25rem] text-root-text-color-muted tab:text-[1.5rem]">
                We'll be back—right meow.
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};
